module.exports = __webpack_public_path__ + "media/images/icon__compete@3x-51bb05847f472c68814d6e4fb23a2379.png";